import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconNewspaper1"><Path d="M2.91322 3.51798C2.69109 3.46845 2.45849 3.52247 2.28091 3.66481C2.10334 3.80715 2 4.02242 2 4.25001V18.6875C2 19.0388 2.24388 19.3431 2.58678 19.4195L11.25 21.3512V5.37686L2.91322 3.51798Z" fill="currentColor"/><Path d="M12.75 5.37686V21.3512L21.4132 19.4195C21.7561 19.3431 22 19.0388 22 18.6875V4.25001C22 4.02242 21.8967 3.80715 21.7191 3.66481C21.5415 3.52247 21.3089 3.46845 21.0868 3.51798L12.75 5.37686Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNewspaper1;
